import { type FragmentType, getFragmentData, graphql } from '../__generated__'
import { ReportStatusTag } from './ReportStatusTag'

const fragments = {
  ReportStatus_translatedCaseStatus: graphql(`
    fragment ReportStatus_translatedCaseStatus on CaseStatusType {
      id
      color
      name
      groupName
    }
  `),
}

export type TranslatedCaseStatus = FragmentType<typeof fragments.ReportStatus_translatedCaseStatus>

type ReportStatusProps = {
  translatedCaseStatus: TranslatedCaseStatus
}

export const ReportStatus = ({
  translatedCaseStatus: _translatedCaseStatus,
}: ReportStatusProps) => {
  const translatedCaseStatus = getFragmentData(
    fragments.ReportStatus_translatedCaseStatus,
    _translatedCaseStatus
  )

  return <ReportStatusTag color={translatedCaseStatus?.color} name={translatedCaseStatus?.name} />
}
